export enum OwnersViewType {
  Shareholder = 0,
  OwnershipStructure = 1,
}

export enum ShareOwnerType {
  Legal = 0,
  Physical = 1,
}
